export default __webpack_public_path__ + "static/media/yellow.3545ab93.jpg";